<ea-button-link
	id="edGetLiveHelp"
	[name]="buttonText"
	(onClick)="loadChatWidget()"
	data-cy="live-chat-link"
>
	{{ buttonText }}
</ea-button-link>
